var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M584-470.33 536.33-518 706-733.33H321L254.33-800H768q22.33 0 32.67 20 10.33 20-4 38L584-470.33Zm221.67 411L560-305v105q0 17-11.5 28.5T520-160h-80q-17 0-28.5-11.5T400-200v-265L59.33-805.67l47.34-47.66 746.66 746.66-47.66 47.34ZM536.33-518Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOff);
export default __webpack_public_path__ + "static/media/filter-off.20110e0dd397b0cf96821badf57e1c54.svg";
export { ForwardRef as ReactComponent };